import React from 'react';
import '../../style/css/App.css';

import {
    Col,
    Container,
    Icon,
    Row
} from "design-react-kit";

import 'bootstrap-italia/dist/css/bootstrap-italia.min.css';
import 'typeface-titillium-web';
import 'typeface-roboto-mono';
import 'typeface-lora';
import {properties} from "../../config/properties";

const Footer = () => {

    var url = new URL( window.location.href);
    let lang2 = url.searchParams.get("lang")!=null ? url.searchParams.get("lang") : "it";

    return (


        <footer className="it-footer mt-lg-4">
            <div className="it-footer-main ">

                <Container>
                    <section>
                        <Row className="clearfix">
                            <Col sm={12}>
                                <br/>
                                <div className="it-brand-text" align={"right"}>
                                        <span>&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://www.instagram.com/infocamere/">
                                            <img
                                                src={"https://www.infocamere.it/.resources/InfoCamere-Module/webresources/img/icn/icn_instagram.svg"}/>
                                        </a></span>

                                    <span>&nbsp;&nbsp;&nbsp;&nbsp;<a
                                        href="https://www.facebook.com/InfoCamere">
                                         <img
                                             src={"https://www.infocamere.it/.resources/InfoCamere-Module/webresources/img/icn/icn_facebook.svg"}/>
                                        </a></span>

                                    <span>&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://x.com/infocamere">

                                        <img
                                            src={"https://www.infocamere.it/.resources/InfoCamere-Module/webresources/img/icn/icn_twitter.svg"}/>
                                    </a></span>
                                    <span>&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://www.linkedin.com/company/infocamere">
                                            <img
                                                src={"https://www.infocamere.it/.resources/InfoCamere-Module/webresources/img/icn/icn_linkedin.svg"}/>
                                        </a></span>

                                    <span>&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://www.youtube.com/user/ICRoma">
                                            <img
                                                src={"https://www.infocamere.it/.resources/InfoCamere-Module/webresources/img/icn/icn_youtube.svg"}/>
                                        </a></span>


                                </div>
                                <div className="it-brand-wrapper">


                                    <div className="it-brand-text">
                                        <h5>{properties.labels.footer.progettoDi} </h5>
                                        <br/>
                                        <a href={"https://infocamere.it/"}>
                                           <Icon src={properties.baseAppUrl+properties.baseImages + '/ic-logo.svg'} height={'50'} />
                                       </a>

                                        </div>

                                </div>
                                <div className="it-brand-text" align={"right"}>

                                    <h6>{properties.labels.footer.servizioRealizzato}  &nbsp;
                                        <a href={"https://infocamere.it/"}>
                                            <Icon src={properties.baseAppUrl+properties.baseImages + '/ic-logo.svg'} height={'50'} />
                                        </a>                                    </h6>
                                    <div align={"right"} style={{align:"right",color:"white"}}>

                                        {properties.labels.footer.indirizzoIC}

                                        <br/>
                                        {properties.labels.footer.pivaCFIC}
                                        <br/>{properties.labels.footer.codLeiIC}

                                    </div>

                                </div>

                            </Col>
                        </Row>
                    </section>

                </Container>
                <br/>
            </div>

            <div className="it-footer-small-prints clearfix">
                <Container>

                  <br/>

                    <ul className="it-footer-small-prints-list list-inline mb-0 d-flex flex-column flex-md-row"
                        style={{color: "white"}}>

                        <li className="list-inline-item">

                            <a href={'https://informative.infocamere.it/specimenfirme'}
                               target={"_blank"}>Privacy, Cookie Policy, Condizioni generali di utilizzo</a>
                        </li>

                    </ul>


                </Container>


            </div>

        </footer>

    );
};

export default Footer;